import React from 'react'
import styles from './UtilityRow.module.css'
// import GameMenu from '../GameMenu/GameMenu'
import {GameMenu} from '@themed-components';
import Topup from '../Topup/Topup'
import HandHistory from '../HandHistory/HandHistory'
import TableStats from '../TableStats/TableStats'
import { 
  usePlayerSeat as useGamePlayerSeat,
  useDealObject,
  useIsTourneyGame
} from '@/src/hooks/data/useGameTable'
import { doesExist } from '../../../Common/utils/GameUtils'
import GameScrollButton from '../GameScrollButton/GameScrollButton';
import gameAssets from '@themed-assets';
import useTourneyDealMaking from '@/src/hooks/utils/useTourneyDealMaking'


export default function UtilityRow({ tempTableId }) {

    const playerSeat = useGamePlayerSeat(tempTableId);
    const dealObject = useDealObject(tempTableId);
    const isTourneyGame = useIsTourneyGame(tempTableId);

    const { handleDealClick } = useTourneyDealMaking(tempTableId);

    const CheckTourneyDeal = () => {
      if (
        playerSeat !== null &&
        playerSeat !== undefined &&
        isTourneyGame &&
        dealObject?.dealStarted
      ) {
        return (
          <div
            className={`${styles.dealButton} ${
              dealObject?.dealOpted ? styles.dealOpted : ""
            } ${dealObject?.pendingAck ? styles.dealDisabled : ""}`}
            id="deal-started-wrapper"
            onClick={handleDealClick}
          >
            <img
              className={styles.dealIcon}
              src={
                dealObject?.dealOpted
                  ? gameAssets?.dealGoldIcon
                  : gameAssets?.dealGrayIcon
              }
            />
            <div
              className={`${styles.dealText}${
                dealObject?.dealOpted ? ` ${styles.dealOptText}` : ""
              }`}
            >
              {dealObject?.currentPlayerCount > 0
                ? `DEAL ${dealObject?.optedCount}/${dealObject?.currentPlayerCount}`
                : "DEAL"}
            </div>
          </div>
        );
      }
    };

    return (
        <div className={styles.utilityRow}>
            <div className={styles.utilityRowLeft}>
                {/* {
                    doesExist(playerSeat) ?
                        <Topup tempTableId={tempTableId} />
                        : null
                }
                {
                    doesExist(playerSeat) ?
                        <HandHistory tempTableId={tempTableId} />
                        : null
                } */}
                <GameScrollButton />
            </div>
            <div className={styles.utilityRowRight}>
                {/* {
                    doesExist(playerSeat) ?
                        <TableStats tempTableId={tempTableId} />
                        : null
                } */}

                <CheckTourneyDeal />
            </div>
        </div>
    )
}
